import { Icon } from '@acme/assets';
import { Button } from 'flowbite-react';
import { useCallback, useState } from 'react';
import { twMerge } from 'tailwind-merge';

export type CopyableTextProps = {
  value: string | null | undefined;
  label?: string | null;
  sizeIcon?: number;
  className?: string;
  classNameButton?: string;
};

export const CopyableText = ({
  value,
  label,
  className = '',
  classNameButton,
}: CopyableTextProps) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(() => {
    if (value == null || value === '') return;
    navigator.clipboard.writeText(value).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  }, [value]);

  if (value == null || value === '') {
    return <span className="text-gray-400">—</span>;
  }

  return (
    <div className={`relative flex items-start gap-2 ${className}`}>
      <div className="break-all text-gray-900">{label ?? value}</div>
      <div className="relative shrink-0">
        <Button
          color="green"
          size="xs"
          className={twMerge(
            'shrink-0 bg-green-100 text-green-900 hover:bg-green-50',
            classNameButton
          )}
          onClick={handleCopy}
          title="Копировать"
        >
          <Icon name="copy-outline" size={16} />
        </Button>
        {copied && (
          <div
            className="absolute left-1/2 top-full z-10 mt-1 -translate-x-1/2 whitespace-nowrap rounded bg-gray-900 px-2 py-1 text-xs text-white"
            role="tooltip"
          >
            Скопировано
          </div>
        )}
      </div>
    </div>
  );
};
